import { DefaultLayout } from "src/layouts/DefaultLayout";
import { GuardUnauthenticated } from "src/components/GuardUnauthenticated";
import { LoginWithAdsDisabled } from "src/components/Login";
import { useState } from "react";
import { toastSuccess } from "src/libs/toast-lib";
import { ResendVerifyModal } from "src/components/AccountVerify/ResendVerifyModal";

export default function LoginPage() {
  const [showVerify, setShowVerify] = useState(false);
  const [unconfirmedEmail, setUnconfirmedEmail] = useState("");

  const handleVerifyComplete = () => {
    toastSuccess(
      "You should receive a verification email shortly. Click the link in the email to verify your account and then log in.",
      { autoClose: 12000 }
    );
  };

  const handleAccountUnconfirmed = (email: string) => {
    setShowVerify(true);
    setUnconfirmedEmail(email);
  };

  return (
    <GuardUnauthenticated>
      <DefaultLayout>
        <ResendVerifyModal
          isOpen={showVerify}
          setIsOpen={setShowVerify}
          email={unconfirmedEmail}
          message="You must verify your account before logging in."
          onComplete={handleVerifyComplete}
        />
        <LoginWithAdsDisabled onAccountUnconfirmed={handleAccountUnconfirmed} />
      </DefaultLayout>
    </GuardUnauthenticated>
  );
}

LoginPage.enableSessionRecording = true;
